// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar___1jWCc","labelTag":"labelTag___nsCV7","content":"content___1W0lO"};